// Pauses a product gallery video when its slide leaves the view: the customer moved to another photo, or scrolled
// away. Loaded by sections/almila-product-video.liquid only for products whose media holds a video.
(() => {
  const videos = document.querySelectorAll('.single-product-image-video video');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
    }
  }, { threshold: 0.5 });
  videos.forEach((video) => observer.observe(video));
})();
